module.exports = {"libs.constants.noticeMessage.noticeShowContact":"Wenn dieser Fehler weiterhin auftritt, kontaktieren Sie uns unter https://choosemuse.com/contactsupport","libs.constants.noticeMessage.general":"Entschuldigung, etwas ist schief gelaufen. Bitte versuchen Sie es erneut.","libs.constants.sessionTimeout.notificationMessage":"Sie wurden aufgrund von Inaktivität von Ihrer Sitzung abgemeldet. Melden Sie sich in Ihrem Konto an, um die Sitzung fortzusetzen.","libs.constants.auth.notificationMessage":"Sie müssen sich zuerst anmelden"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/de/libs/constants.json
// module id = 874
// module chunks = 0